<div class="d-flex flex-column vh-100">
  <static-hdr></static-hdr>
  
  <section class="container flex-grow-1">
    <div class="card card-custom h-100">
      <div class="card-body">
        
        <h1 class="font-weight-bold text-primary mb-8 mt-4">سياسة الخصوصية</h1>
        
        
        <!-- in case there in no content yet -->
        <div class="bg-danger-o-5 p-10">
          <div class="d-flex bg-danger-o-5 justify-content-center p-10">
            <img class="seecLogo" src="/assets/common/images/emptypage.svg" alt="Empty Page" />
          </div>
          <h3 class="text-center">Under</h3>
          <h1 class="text-center text-black-50">Construction</h1>
        </div>


      </div>

      <div class="card-footer d-flex justify-content-between">
        <button type="button" class="btn btn-outline-light btn-lg px-8" [routerLink]="['/home']">
          عودة
        </button>
      </div>

    </div>
  </section>
  
  <static-ftr></static-ftr>
</div>